import { Container, Grid } from "@mui/material";
import React, { useEffect } from "react";
import AOS from 'aos';
import 'aos/dist/aos.css'
import FeaturesCard from "../../Components/FeaturesCards";
import SectionHeading from "../../Components/SectionHeading";

import quality from "../../images/quality.png"
import tournament from "../../images/tournament.png"
import oneMatch from "../../images/oneMatch.png"
import metaverse from "../../images/metaverse.png"

const Features = () => {
    useEffect(() =>{
        AOS.init({duration: 1500})
    })
    return(
        <div id="features" className="mt-5 py-5 MS---overflow-x">
            <Container>
                <Grid
                    container
                    justifyContent="flex-start"
                    alignContent="center"
                >
                    <Grid
                        xs={12}
                        md={6}
                        className="align-self-center"
                        data-aos="fade-up"
                    >
                        <SectionHeading
                            subHeading="Features"
                            heading="Much more in store!" 
                        />
                        <p style={{maxWidth:460}}>
                            MetaSnooker has a whole lot going on for it. The game aims to develop a functioning proof of concept within the next few months to help make MetaSnooker an amazing and enjoyable experience for everyone involved. The initial release will gather feedback from the community to help bring a polished product for everyone to enjoy. MetaSnooker will be a place where people can gather, make friends and play to their hearts' content.
                        </p>
                    </Grid>
                    <Grid
                        container
                        justifyContent="center"
                        alignContent="center"
                        xs={12}
                        md={6}
                        className="position-relative text-center align-self-center pl-sm-4 mx-auto"
                    >
                        <Grid
                            xs={10}
                            sm={6}
                            className="mt-md-5 mx-auto text-center"
                        >
                            <FeaturesCard 
                                icon={quality}
                                heading = "Quality"
                                text = "Our vigilant team works around the clock to take community feedback and make improvements to the game in regular future updates."
                                customClass = "features-card-1 mx-auto"
                                cardAnimate = "zoom-in"
                            />
                            
                            <FeaturesCard 
                                icon={oneMatch}
                                heading = "PVP"
                                text = "Players can compete against other players in a one on one match when they log in to the game. The prize money goes to the winner according to the wager amount agreed on by both parties."
                                customClass = "features-card-2 mx-auto"
                                cardAnimate = "zoom-in"
                            />
                        </Grid>
                        <Grid
                            xs={10}
                            sm={6}
                            className="mtn-5 mx-auto"
                        >
                            <FeaturesCard 
                                icon={tournament}
                                heading = "Tournaments"
                                text = "Tournaments will allow players to compete for a much larger prizepool and win big in the process. It is slated to be included in the game 6 months after launch."
                                customClass = "features-card-3 mx-auto"
                                cardAnimate = "zoom-in"
                            />
                            
                            <FeaturesCard 
                                icon={metaverse}
                                heading = "MetaVerse"
                                text = "This is where the 'Meta' in MetaSnooker comes in. Getting into the Metaverse is where things really get started, MetaSnooker in the Metaverse is going to be reminiscent of Snooker Clubs in real life."
                                customClass = "features-card-4 mx-auto"
                                cardAnimate = "zoom-in"
                            />
                        </Grid>
                        
                        
                        
                        
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}
export default Features;